export enum InstanceType {
	// TODO
	City = 1,
	CityPart = 2,
	//ObchodniRegion      = 3,
	ApartmentLocation = 10,
	HousingBlock = 11,
	Floor = 12,
	Apartment = 13,
	//LokalitaRD          = 20,
	//TypovyRD            = 21,
	//RodinnyDum          = 23,
	//GeneraceTypovyRD    = 25,
	//LokalitaParcely     = 30,
	//Parcela             = 33,
	ParkingPlace = 40,
	StorageFacility = 41,
	ConstructionPhase = 61,
	//Akce                = 71,
	//Dodavatele          = 81
}
